import type { AudioPlayerHandle } from '@neo/primitives/audio-player'
import { createContext, type ReactNode, useContext, useRef } from 'react'

interface AudioPlayerContextType {
  audioRef: React.RefObject<AudioPlayerHandle> | null
  seekToTime: (timeInSeconds: number) => void
}

const AudioPlayerContext = createContext<AudioPlayerContextType | null>(null)

interface AudioPlayerProviderProps {
  children: ReactNode
}

export const AudioPlayerProvider = ({ children }: AudioPlayerProviderProps) => {
  const audioRef = useRef<AudioPlayerHandle | null>(null)

  const seekToTime = (timeInSeconds: number) => {
    if (!audioRef.current) return
    audioRef.current.seekToTime(timeInSeconds)
  }

  return (
    <AudioPlayerContext.Provider value={{ audioRef, seekToTime }}>
      {children}
    </AudioPlayerContext.Provider>
  )
}

export const useAudioPlayer = () => {
  const context = useContext(AudioPlayerContext)
  if (!context) {
    throw new Error('useAudioPlayer must be used within an AudioPlayerProvider')
  }
  return context
}
